<template>
  <a-row>
    <a-row class="search-body">
      <a-col :span="24">
        <bidding-search :keywords="keywords" :postdata="postdata" :region="region" @inputchange="inputChange" @search="search"/>
      </a-col>
    </a-row>
    <a-row class="content-list" v-if="tp_result.length > 0">
      <bidding-list :list="tp_result" @checked="checkedItems"/>
    </a-row>
  </a-row>
</template>

<script>

import {BiddingSearch, BiddingList} from '@/com/Bidding'

export default {
  name: 'Bidding',
  props: {
    postdata: {
      type: Object,
      default: function() {
        return {}
      }
    },
    result: {
      type: Array,
      default: function() {
        return []
      }
    },
    relationitem: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      tab: 'bid',
      keywords: "",
      region: "",
      tp_postdata: this.postdata,
      tp_result: this.result,
      tp_relationitem: this.relationitem
    }
  },
  components: {
    BiddingSearch,
    BiddingList
  },
  watch: {
    tp_postdata(newvalue, oldvalue) {
      this.tp_postdata = newvalue
    },
    postdata(newvalue, oldvalue) {
      this.tp_postdata = newvalue
    },
    tp_result(newvalue, oldvalue) {
      this.tp_result = newvalue
    },
    result(newvalue, oldvalue) {
      this.tp_result = newvalue
    },
    tp_relationitem(newvalue, oldvalue) {
      this.tp_relationitem = newvalue
    },
    relationitem(newvalue, oldvalue) {
      this.tp_relationitem = newvalue
    }
  },
  methods: {
    inputChange: function(keywords, region) {
      this.keywords = keywords
      this.region = region
    },
    checkedItems: function(item) {
      for(let key in item) {
        this.tp_relationitem[key] = item[key]
      }

      this.$store.commit('updaterelationitem', this.tp_relationitem)
      this.$emit('checked', this.tp_relationitem)
    },
    search: function(post, result, list) {
      this.tp_postdata = post;
      this.tp_result = result;
      this.tp_relationitem = list
      this.$emit('search', this.tp_postdata, this.tp_result)
    }
  },
  created() {
    let relationitem = this.$store.getters.getRelationItem(1)
    let names = ""
    for (let key in relationitem) {
      names = names + relationitem[key] + "\n"
    }
    if (this.postdata.keywords) {
      this.keywords = this.postdata.keywords
    } else {
      this.keywords = names
    }
    if (this.postdata.region) {
      this.region = this.postdata.region
    }
  }
}
</script>

<style>
  .search-body {
    border-right: 0px solid #d1d5da;
    border-left: 0px solid #d1d5da;
    border-bottom: 0px solid #d1d5da;
    border-radius: 0px 0px 3px 3px;
  }
  .content-list {
    margin-top: 4px; 
    height: 100%;
    border-left: 1px solid #d1d5da;
    border-right: 1px solid #d1d5da;
    border-radius: 3px;
  }
  .pb8 {
    padding-bottom: 8px;
  }
  .card-border {
    border-top: 0px;
    border-bottom: 1px solid #e1e4e8;
    border-left: 0px;
    border-right: 0px;
  }
  .text-split {
    font-size: 14px;
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
  .mb4 {
    margin-bottom: 4px;
  }
</style>
